var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6V14C2 16.2456 3.75439 18 6 18H14C16.2456 18 18 16.2456 18 14V6C18 3.75439 16.2456 2 14 2H6C3.75439 2 2 3.75439 2 6ZM17 9.05263H18C19.2632 9.05263 20 9.78947 20 11.0526V18C20 19.2632 19.2632 20 18 20H11.0526C9.78947 20 9.05263 19.2632 9.05263 18V17C9.05263 16.4561 8.59649 16 8.05263 16C7.50877 16 7.05263 16.4561 7.05263 17V18C7.05263 20.2456 8.80702 22 11.0526 22H18C20.2456 22 22 20.2456 22 18V11.0526C22 8.80702 20.2456 7.05263 18 7.05263H17C16.4561 7.05263 16 7.50877 16 8.05263C16 8.59649 16.4561 9.05263 17 9.05263Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content_copy.a3d203bb.svg";
export { ForwardRef as ReactComponent };